import styled from 'react-emotion'

import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('div')`
    animation: fade-in 50ms ease-in both;
    background-color: ${themeVars.dark};
    max-width: 275px;
    text-align: center;
    overflow-wrap: break-word;
    border-radius: ${th('radius')};
    color: white;
    font-size: ${th('fontSizes.1')}px;
    left: 0;
    letter-spacing: 0;
    line-height: 1.38;
    padding: ${th('space.2')}px ${th('space.3')}px;
    pointer-events: none;
    position: fixed;
    top: 0;
    z-index: 2147483647;

    a {
      color: ${th('colors.white')};
      text-decoration: none;
    }

    &:before {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: -20px;
      background-color: rgba(255, 255, 255, 0.01);
      content: ' ';
      pointer-events: none;
    }

    &:after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-style: solid;
      border-color: ${themeVars.dark};
    }
  }

  @keyframes :local(fade-in) {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.pink {
    background: #f487ae;

    &:after {
      border-color: #f487ae;
    }
  }

  &.red {
    background: #b93519;

    &:after {
      border-color: #b93519;
    }
  }

  &.right {
    transform: translate(9px, -50%);

    &:after {
      top: 50%;
      left: -7px;
      transform: translateY(-50%);
      border-width: 5.5px 7.61px 5.5px 0;
      border-left-color: transparent;
      border-bottom-color: transparent;
      border-top-color: transparent;
    }
  }

  &.top {
    transform: translate(-50%, calc(-100% - 12px));

    &:after {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 7.61px 5.5px 0 5.5px;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }

  &.bottom {
    transform: translate(-50%, 14px);

    &:after {
      top: -7px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 0 5.5px 7.61px 5.5px;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }

  &.left {
    transform: translate(calc(-100% - 9px), -50%);

    &:after {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-width: 5.5px 0 5.5px 7.61px;
      border-bottom-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
`
